import React from 'react'
import Headerh2 from './components/Headerh2'
import Bodyh2 from './components/Bodyh2'
import Fotterh2 from './components/Footerh2'

export default function HomePageTwo() {
    return (
        <>
            <Headerh2 />
            <Bodyh2 />
            <Fotterh2 />
        </>
    )
}
